import { riskHref } from '../../consumer/workbench';
import type { EvaluationSelection } from './EvaluationPage';

export type EvaluationTab = 'forecasts' | 'watches' | 'sources';
export interface EvaluationLocation {
  selection: EvaluationSelection;
  tab: EvaluationTab;
  forecastOffset: number;
  watchOffset: number;
}
function inputTime(value: string | null): string {
  if (
    !value ||
    !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})?$/.test(value)
  )
    return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  const pad = (n: number, width = 2) => String(n).padStart(width, '0');
  return `${pad(date.getFullYear(), 4)}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}${date.getMilliseconds() ? `.${pad(date.getMilliseconds(), 3)}` : ''}`;
}
function offset(value: string | null): number {
  if (!value || !/^\d+$/.test(value)) return 0;
  const n = Number(value);
  return Number.isSafeInteger(n) && n <= 1000000 && n % 10 === 0 ? n : 0;
}
/** Parse only backend-supported values; invalid links cannot trigger unbounded queries. */
export function parseEvaluationLocation(search: string): EvaluationLocation {
  const p = new URLSearchParams(search);
  const metric = p.get('metric');
  const horizon = p.get('horizon');
  const algorithm = p.get('model') ?? p.get('algorithm');
  let from = inputTime(p.get('from'));
  let to = inputTime(p.get('to'));
  if (from && to && Date.parse(from) > Date.parse(to)) {
    from = '';
    to = '';
  }
  const tab = p.get('tab');
  return {
    selection: {
      metric: metric === 'TEMPERATURE' || metric === 'PARTICULATE' ? metric : '',
      horizon: horizon === '5' || horizon === '10' || horizon === '20' ? horizon : '',
      algorithm: algorithm === 'LOCAL_LINEAR_V1' || algorithm === 'LAST_VALUE_V1' ? algorithm : '',
      from,
      to,
    },
    tab: tab === 'watches' || tab === 'sources' ? tab : 'forecasts',
    forecastOffset: offset(p.get('forecastOffset')),
    watchOffset: offset(p.get('watchOffset')),
  };
}
export function evaluationLocationHref(areaId: string, state: EvaluationLocation): string {
  const selection = state.selection;
  return riskHref('/evaluation', areaId, {
    ...(selection.metric ? { metric: selection.metric } : {}),
    ...(selection.horizon ? { horizon: selection.horizon } : {}),
    ...(selection.algorithm ? { model: selection.algorithm } : {}),
    ...(selection.from ? { from: new Date(selection.from).toISOString() } : {}),
    ...(selection.to ? { to: new Date(selection.to).toISOString() } : {}),
    ...(state.tab !== 'forecasts' ? { tab: state.tab } : {}),
    ...(state.forecastOffset ? { forecastOffset: String(state.forecastOffset) } : {}),
    ...(state.watchOffset ? { watchOffset: String(state.watchOffset) } : {}),
  });
}
